/**
 * Canonical bootstrap user text sent with useChat POST /build-stream.
 * Flask matches this phrase when injecting server-built prompts into the transcript tail on continuation turns.
 *
 * Mirror string in Python: ideoz-ai-api `workbench_stream_constants.WORKBENCH_BUILD_STREAM_TRIGGER`
 */
export const WORKBENCH_BUILD_STREAM_TRIGGER =
  'Proceed with prototype generation in the workbench.';
